export default __webpack_public_path__ + "static/media/Poppins-SemiBoldItalic.52fb92d8.eot";